import { blockAdapterBase } from 'volto-ministerio-publico-federal/helpers/BlockAdapter/BlockAdapter';
import type { SubHomeDestaqueItem } from './helpers';

interface PageBrain {
  Title?: string;
  [key: string]: unknown;
}

/**
 * Ao escolher o conteúdo no campo Destino, herda o título como rótulo.
 *
 * Só preenche rótulo vazio — mesma política de `Blocks/OndeAtua/adapter.ts`:
 * depois que o editor escreveu algo, trocar o destino não apaga o trabalho
 * manual; para o preenchimento voltar a rodar, basta limpar o campo.
 */
export const buildSubHomeDestaqueFields = (
  page: PageBrain,
  item: SubHomeDestaqueItem = {},
): Partial<SubHomeDestaqueItem> =>
  !item.label && page.Title ? { label: page.Title } : {};

export const SubHomeDestaqueBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}: {
  block: string;
  data: Record<string, unknown>;
  id: string;
  onChangeBlock: (block: string, data: unknown) => void;
  value: unknown;
}) => {
  blockAdapterBase(
    block,
    data,
    id,
    onChangeBlock,
    value,
    'items',
    buildSubHomeDestaqueFields,
  );
};

export default SubHomeDestaqueBlockDataAdapter;
